import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { paymentShareWhitelistItemsBackend } from './payment-share-whitelist-items.backend';
import { paymentShareWhitelistItemsReducer } from './payment-share-whitelist-items.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'paymentShareWhitelistItems',
      paymentShareWhitelistItemsReducer,
    ),
    BackendModule.forFeature(
      'paymentShareWhitelistItems',
      paymentShareWhitelistItemsBackend,
    ),
  ],
})
export class DatastorePaymentShareWhitelistItemsModule {}
